import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {XMLHttpRequestHandler} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {newsletterInteractionEmailView_template} from "../components/templates/newsletterInteractionEmailView_template";

declare var ko: any;
declare var page: any;

export class newsletter_interaction_email_view extends vnModule_knockoutJS {

    protected newsletterInteractionEmailView: newsletterInteractionEmailView_template;
    protected XHRHdl: XMLHttpRequestHandler;

    buildContent(): Array<Element> {

        this.newsletterInteractionEmailView = new newsletterInteractionEmailView_template("newsletter_interaction_email_view_template", this.viewModel, this);
        return [this.newsletterInteractionEmailView.build()];
    }

    protected getModuleName(): string {

        return "newsletter_interaction_email_view_template";
    }

    fillPage() {

        this.getNewsletterReferences()
    }

    protected getNewsletterReferences() {

        // LOADING : starts
        this.loadingIn(this.newsletterInteractionEmailView.builtTemplate);

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/newsletter/interaction-emails/references';
        let usrReq_params: Array<Array<string>> = [['references', 'permissions,events,schedules,recipients,segments']];

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onNewsletterRequestReturn;
        this.XHRHdl.execute();
    }

    public onNewsletterRequestReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                obj.loadingOut(obj.newsletterInteractionEmailView.builtTemplate);

                //check if user has article write permissions
                let responseParsed = JSON.parse(req.request.response);

                obj.newsletterInteractionEmailView.setPermissions(responseParsed.permissions)
                obj.newsletterInteractionEmailView.setEvents(responseParsed.events || [])
                obj.newsletterInteractionEmailView.setSchedules(responseParsed.schedules || [])
                obj.newsletterInteractionEmailView.setRecipients(responseParsed.recipients || [])
                obj.newsletterInteractionEmailView.setSegments(responseParsed.segments || [])

                obj.getNewsletterInteractionEmailDataForView()
            })
        }
    }

    private getNewsletterInteractionEmailDataForView() {

        this.loadingIn(this.newsletterInteractionEmailView.builtTemplate);

        let url : string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/newsletter/interaction-emails/get/' + this.getVnAppZone().app.params.id + '/';
        let request_parameters : Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(url, request_parameters, this);
        this.XHRHdl.onReadyStateFunction = this.onGetNewsletterInteractionEmailDataForView;
        this.XHRHdl.execute();
    }

    private onGetNewsletterInteractionEmailDataForView(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                let newsletterInteractionEmail = responseParsed.interactionEmail;
                obj.newsletterInteractionEmailView.setNewsletterInteractionEmailData(newsletterInteractionEmail);

            });

            obj.loadingOut(obj.newsletterInteractionEmailView.builtTemplate);
        }
    }

    protected onClickEditNewsletterInteractionEmail(id){

        let brandId = this.getVnAppZone().app.params.idBrand
        page("/brand/" + brandId + "/newsletter/interaction-emails/edit/" + id + '/')
    }

    protected onClickCancel(){

        let brandId = this.getVnAppZone().app.params.idBrand
        page.redirect("/brand/" + brandId + "/newsletter/interaction-emails/")
    }
}



// WEBPACK FOOTER //
// ./js/modules/newsletter_interaction_email_view.ts